export default __webpack_public_path__ + "static/media/vehicularTraffic3.9686e5c1.jpg";